import { ClientFetchService } from "@lib/helpers/clientFetchService";
import { useAuth } from "@lib/auth/useAuth";
import { useApi } from "@lib/helpers/useApi";
import { QueryKeys } from "@lib/enums/QueryKeys";
import { hasLoyaltyPointsHistory } from "@lib/utils/loyalty";
import type { UseQueryResult } from "@tanstack/react-query";
import type { ApiError, QueryConfig } from "@lib/helpers/useApi";
import type { LoyaltyTransactionsResponse } from "@interfaces/ecco-club/LoyaltyPointsTransactions";

export const useLoyaltyTransaction = (
    customConfig: QueryConfig<LoyaltyTransactionsResponse> = {}
): UseQueryResult<LoyaltyTransactionsResponse, ApiError> => {
    const { session, status } = useAuth();
    const { enabled = true, ...queryConfig } = customConfig;

    return useApi.useAsync<LoyaltyTransactionsResponse>(
        [QueryKeys.getLoyaltyTransactionsPoints, session?.anonymousId, session?.ucid],
        async () => {
            if (!session?.ucid) {
                return {} as LoyaltyTransactionsResponse;
            }
            return await ClientFetchService.get(`/api/user/get-loyalty-transactions`);
        },
        {
            ...queryConfig,
            enabled: status === "authenticated" && hasLoyaltyPointsHistory ? enabled : false,
        }
    );
};
